import { Sx } from "dripsy";
import { createContext } from "react";

const NotificationCardThemeContext = createContext<{ textSx?: Sx }>({});

export { NotificationCardThemeContext };
